import {t} from 'i18next';
import {z} from 'zod';

export const projectFieldGroupSchema = () =>
  z.object({
    fieldGroupLabel: z
      .string()
      .trim()
      .min(1, {
        message: t(
          'manageProjectField.addProjectFieldGroup.errors.fieldGroupNameRequired'
        ),
      }),
  });

export type ProjectFieldGroupForm = z.infer<
  ReturnType<typeof projectFieldGroupSchema>
>;
